import React from 'react'
import { P, Div, CircleLoader } from '@drifthq/tide-core'

const Loading = () =>  (
  <Div className="app-loading-placeholder">
    <CircleLoader size="large" className="placeholder-spinner"/>
    <P>Just a moment...</P>
  </Div>
)

export default Loading



// WEBPACK FOOTER //
// ./src/layouts/LoadingPage/index.js